import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["open"]
const _hoisted_2 = { class: "actions" }
const _hoisted_3 = ["disabled"]

import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';


export default /*@__PURE__*/_defineComponent({
  __name: 'RescheduleDialog',
  props: {
    open: { type: Boolean },
    orderItemId: { type: Function }
  },
  emits: ["close", "done"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const newSlotId = ref('');
const busy = ref(false);

async function submit(): Promise<void> {
    busy.value = true;
    try {
        // TODO(v2-cutover): /admin-api/consultation-bookings/<id>/reschedule/ was
        // removed with the ConsultationBooking model. V2 reschedule runs through
        // commerce reserve_consultation_slot (sets the 'rescheduled' flag on the
        // OrderItem's Reservation). Re-point at the V2 admin reservations
        // reschedule action resolved from the OrderItem,
        // i.e. POST /admin-api/reservations/<reservation_id>/reschedule/. Requires
        // BE coordination for orderItemId -> reservation resolution.
        await request({
            method: 'post',
            url: `/admin-api/reservations/${props.orderItemId()}/reschedule/`,
            data: { new_slot_id: newSlotId.value },
        });
        emit('done');
    } finally {
        busy.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", {
    open: _ctx.open,
    class: "action-dialog"
  }, [
    _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Перенести личную сессию", -1)),
    _createElementVNode("label", null, [
      _cache[2] || (_cache[2] = _createTextVNode("ID нового слота (UUID) ")),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newSlotId).value = $event)),
        type: "text",
        placeholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
      }, null, 512), [
        [_vModelText, newSlotId.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn--primary",
        disabled: busy.value || !newSlotId.value,
        onClick: submit
      }, _toDisplayString(busy.value ? 'Переношу…' : 'Перенести'), 9, _hoisted_3),
      _createElementVNode("button", {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, "Отмена")
    ])
  ], 8, _hoisted_1))
}
}

})